<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Usuario</h3>
      </div>
      <div class="inline">
        <button type="button" @click="crearNuevoUsuario()" class="btn-bus200">
          <i class="fa fa-user-plus"></i><span>Crear usuario</span>
        </button>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Datos del usuario</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field id="nombre" v-model="form.nombre" placeholder="Escriba un nombre...">
                Nombre*
                <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.nombre[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field id="email" v-model="form.email" placeholder="Escriba un e-mail...">
                E-mail*
                <span v-if="errores.email" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.email[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                :readonly="tipoEdicion === 'E'"
                id="nombre_usuario"
                v-model="form.nombre_usuario"
                placeholder="Escriba un nombre de usuario..."
              >
                Nombre de usuario*
                <span
                  v-if="errores.nombre_usuario"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.nombre_usuario[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="form-group">
                <input-field
                  :type="tipoPassword"
                  id="password"
                  v-model="form.password"
                  placeholder="Escriba una contraseña..."
                >
                  Contraseña{{ tipoEdicion === 'N'?'*':'' }}
                  <span
                    v-if="errores.password"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.password[0] }}</strong>
                  </span>
                </input-field>
                <button @click="generarPassword()" tooltip="Generar contraseña" class="btn-secondary btn--text" type="button">
                  <i class="fa fa-refresh"></i>
                </button>
                <button @click="visualizarClave()" :tooltip="verPassword ? 'Ocultar contraseña' : 'Visualizar contrasña'" class="btn-info btn--text" type="button">
                  <i :class="verPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                :type="tipoPassword"
                id="password_confirmation"
                v-model="form.password_confirmation"
                placeholder="Escriba una contraseña..."
              >
                Confirmación de contraseña{{ tipoEdicion === 'N'?'*':'' }}
                <span
                  v-if="errores.password_confirmation"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.password_confirmation[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 form-inline">
            <p>
              <label v-show="esSuperadmin" for="esAdministrador">
                <input
                  type="checkbox"
                  name="esAdministrador"
                  id="esAdministrador"
                  v-model="form.es_administrador"
                />
                <span>Es administrador</span>
              </label>
            </p>
            <p>
              <label for="esVendedor">
                <input
                  type="checkbox"
                  name="es_vendedor"
                  id="esVendedor"
                  v-model="form.es_vendedor"
                />
                <span>Es vendedor</span>
              </label>
            </p>
            <p v-show="form.es_vendedor">
              <label for="esComisionable">
                <input
                  type="checkbox"
                  name="es_comisionable"
                  id="esComisionable"
                  v-model="form.es_comisionable"
                />
                <span>Es comisionable</span>
              </label>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button type="button" @click="guardar" class="btn-primary">
              <i class="fa fa-save"></i>
              <span>Guardar usuario</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tipoEdicion === 'E'" class="card mt-2">
      <div class="card__title">
        <h5>Permisos del usuario</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputEmpresa"
                  v-model="selectedEmpresa"
                  :options="empresas"
                  label="descripcion"
                  id="empresa"
                  placeholder="Seleccione..."
                ></v-select>
                <label for="empresa">Empresa</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tipoEdicion === 'E' && selectedEmpresa !== null" class="row mt-2">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h6>Roles</h6>
          </div>
          <div class="card__content">
            <checked-listbox name="roles[]" v-model="formPermisos.roles" :items="roles"></checked-listbox>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tipoEdicion === 'E' && selectedEmpresa !== null" class="row mt-2">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__content">
            <button @click="guardarPermisos" class="btn-primary">
              <i class="fa fa-save"></i>
              <span>Guardar permisos</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    empresas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    esSuperadmin: {
      type: Boolean,
      required: false,
      default: false
    },
    usuarioId: {
      required: false,
      default: null
    }
  },
  data: function() {
    return {
      selectedEmpresa: null,
      verPassword: false,
      tipoPassword: 'password',
      formPermisos: {
        empresa_id: "",
        roles: []
      },
      form: {
        nombre: "",
        nombre_usuario: "",
        password: "",
        password_confirmation: "",
        email: "",
        es_administrador: false,
        _method: undefined,
        es_vendedor: false,
        es_comisionable: false,
      },
      tipoEdicion: "N",
      errores: {},
      roles: [],
      id: this.usuarioId
    };
  },
  methods: {
    crearNuevoUsuario: function(){
      swal.fire({
        title: '¿Desea crear un nuevo usuario?',
        text: 'Se recargará la página para crear un nuevo usuario.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          window.open(url + '/usuarios/create', '_self');
        }
      });
    },
    visualizarClave: function(){
      this.verPassword = !this.verPassword;
      this.tipoPassword = this.verPassword ? 'text' : 'password';
    },
    generarPassword: function(){
      // Generar contraseña aleatoria DE 8 CARACTERES
      const caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
      this.form.password = Array.from({ length: 8 }, () => caracteres.charAt(Math.floor(Math.random() * caracteres.length))).join('');
      this.form.password_confirmation = this.form.password;
    },
    guardarPermisos: function() {
      let that = this;
      if (that.formPermisos.roles.length === 0)
        swal("Debe seleccionar al menos un rol.", "Aviso", "warning");
      else {
        axios
          .post(url + "/usuarios/" + that.id, that.formPermisos)
          .then(function() {
            swal(
              "Los permisos fueron almacenados exitósamente.",
              "Realizado",
              "success"
            );
          })
          .catch(function() {
            swal("Hubo un error, intente nuevamente.", "Error", "error");
          });
      }
    },
    guardar: function() {
      let that = this;
      let urlRequest = url + "/usuarios";
      if (this.tipoEdicion === "E") {
        this.form._method = "PUT";
        urlRequest += "/" + this.id;
      }
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          if (that.tipoEdicion === "N") {
            that.id = response.data.id;
            that.tipoEdicion = "E";
          }
          swal("El usuario fue almacenado.", "Realizado", "success");
        })
        .catch(function(error) {
          if (error && error.response) {
            let status = error.response.status;
            if (status === 422) {
              that.errores = error.response.data.errors;
              swal("El formulario tiene errores.", "Aviso", "warning");
              return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputEmpresa: function() {
      if (this.selectedEmpresa !== null) {
        this.formPermisos.empresa_id = this.selectedEmpresa.id;
        let that = this;
        axios
          .get(
            url +
              "/usuarios/" +
              this.formPermisos.empresa_id +
              "/" +
              this.id +
              "/datos"
          )
          .then(function(response) {
            that.roles = response.data.roles;
            that.formPermisos.roles.splice(0, that.formPermisos.roles.length);
            for (let i = 0; i < response.data.roles_usuario.length; i++)
              that.formPermisos.roles.push(response.data.roles_usuario[i]);
          })
          .catch(function() {
            swal(
              "No se pudo cargar los datos de la empresa y el usuario.",
              "Error",
              "error"
            );
          });
      } else this.formPermisos.empresa_id = "";
    }
  },
  mounted: function() {
    if (this.usuarioId !== null && this.usuarioId !== "") {
      let that = this;
      axios
        .get(url + "/usuarios/" + this.usuarioId)
        .then(function(response) {
          that.form.nombre = response.data.nombre;
          that.form.nombre_usuario = response.data.nombre_usuario;
          that.form.es_administrador = response.data.es_superadmin === "A";
          that.form.email = response.data.email;
          if (response.data.usuario_local != null) {
            that.form.es_vendedor =
              response.data.usuario_local.es_vendedor === "S";
            that.form.es_comisionable = response.data.usuario_local.es_comisionable === "S";
          }
          that.tipoEdicion = "E";
        })
        .catch(function() {
          swal(
            "Hubo un error al cargar el usuario seleccionado.",
            "Error",
            "error"
          );
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue